import { useEffect, useState } from 'react';
import { CoveringsAPI } from '../../../services/external/APIs/coverings/Coverings.api';
import { CoverByAuthorizer } from '../../../models/coverings/coverByAuthorizer';

export const useGetCoversAuthorizer = () => {
    const [coversList, setCoversList] = useState<CoverByAuthorizer[]>([]);
    const [coversListCopy, setCoversListCopy] = useState<CoverByAuthorizer[]>([]);
    const [isLoadingCovers, setIsLoadingCovers] = useState(false);
    const [reloadings, setReloadings] = useState(0);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        setIsLoadingCovers(true);
        CoveringsAPI.getPendingRequestByAuthorizer()
            .then((res) => {
                setCoversList(res);
                setCoversListCopy(res);
            })
            .catch((err) => {
                setErrorMessage(err);
            })
            .finally(() => {
                setIsLoadingCovers(false);
            });
    }, [reloadings]);

    const handlerReloading = () => {
        setReloadings(reloadings + 1);
    };

    return {
        coversList,
        coversListCopy,
        isLoadingCovers,
        handlerReloading,
        errorMessage,
        setCoversListCopy,
    };
};
